import Vue from 'vue'  //独立router需要引入vue
import VueRouter from 'vue-router' //引入router
import NProgress from "nprogress"; //进入进度条


const routerReplace = VueRouter.prototype.replace

VueRouter.prototype.replace = function replace(location) {
    return routerReplace.call(this, location).catch(error => error)
}

//push
const routerPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}

Vue.use(VueRouter)  //将router注册到vue对象种

const routes = [
  {path:'/', redirect:'/content'},
  {
    path: '/',
    name: 'Main',
    component: () => import("./views/Main.vue"), //引入后台主模板
    children: [  //后台右侧显示区
      {path:'/home', name:'Home',  component: () => import("./views/Home.vue")},  //首页
      {path:'/content', name:'Content',  component: () => import("./views/Content.vue")},  //文件管理
      {path:'/article', name:'Article',  component: () => import("./views/Article.vue")},  //文件查看
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("./views/Login.vue"),
    meta: { isPublic: true }
  },
  {
    path: "*",
    name: "NotFound",
    component: () => import("./views/NotFound.vue"),
  },
]

const router = new VueRouter({
  mode: 'hash',
  // base: '/admin/',
  // base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active'
})

//路由监听
router.beforeEach((to, from, next) => {
  if (!to.meta.isPublic && !localStorage.getItem('token') && !localStorage.getItem('quanjian')) { //不是公开访问的页面 并且 无token
    Vue.prototype.$message({ type: "error", message: "请先登录" });
    return next('/login')
  }

  // 如果有token并且是公共页面，重定向到/user页面
  // if (to.meta.isPublic && localStorage.getItem('token')) {
  //   return next('/stf_mgt');
  // }

  NProgress.start(); //进度条开始
  next()
})

router.afterEach(() => {
  NProgress.done();  //进度条完成
})

// router.$addRoutes = (routes) => {
//   // 自定义一个$addRoutes的方法
//   // 通过新建一个全新的 Router，然后将新的 Router.matcher 赋给当前页面的管理 Router，以达到更新路由配置的目的。自定义的$addRoutes，就是实现这个功能
//   router.matcher = new VueRouter().matcher;
//   router.addRoutes(routes);
// };


export default router
